import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/AncientWorks',
      name: 'AncientWorks',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AncientWorks.vue'),
      children: []
    },
    {
      path: '/VolumeList',
      name: 'VolumeList',
      component: () => import('../views/VolumeList.vue'),
    },
    {
      path: '/Atlas',
      name: 'Atlas',
      component: () => import('../views/Atlas/Atlas.vue'),
    },
    {
      path: '/ReadBook',
      name: 'ReadBook',
      component: () => import('../views/ReadBook/ReadBook.vue'),
    },
    {
      path: '/book_shili',
      name: 'book_shili',
      component: () => import('../views/ReadBook/book_shili.vue'),
    },
    {
      path: '/PersonalCenter',
      name: 'PersonalCenter',
      component: () => import('../views/PersonalCenter/PersonalCenter.vue'),
      children: [
        {
          path: '', // 这是一个空路径，代表根路径
          redirect: '/PersonalData' // 重定向到/PersonalData
        },
        {
          path: '/PersonalData',
          name: 'PersonalData',
          component: () => import('../views/PersonalCenter/PersonalData.vue'),
        },
        {
          path: '/MyCollection',
          name: 'MyCollection',
          component: () => import('../views/PersonalCenter/MyCollection.vue'),
        },
        {
          path: '/MyTagging',
          name: 'MyTagging',
          component: () => import('../views/PersonalCenter/MyTagging.vue'),
        }
      ]
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('../views/Login/Login.vue'),
      children: [
        {
          path: '', // 这是一个空路径，代表根路径
          redirect: '/SignIn' // 重定向到/SignIn
        },
        {
          path: '/SignIn',
          name: 'SignIn',
          component: () => import('../views/Login/SignIn.vue'),
        },
        {
          path: '/Register',
          name: 'Register',
          component: () => import('../views/Login/Register.vue'),
        },
        {
          path: '/Binding',
          name: 'Binding',
          component: () => import('../views/Login/Binding.vue'),
        }
      ]
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的滚动位置（例如页面刷新后），则恢复到该位置
    if (savedPosition) {
      return savedPosition
    }
    
    // 跳转到任意页面时，滚动到页面顶部
    return { top: 0 }
  }
})

export default router
